import StatusBadge from '../shared/StatusBadge';
import JsonViewer from '../shared/JsonViewer';
import { FullTaskState } from '../../types';

interface TaskDetailProps {
  taskId: string;
  fullState?: FullTaskState | null;
}

export default function TaskDetail({ taskId: _taskId, fullState }: TaskDetailProps) {
  return (
    <div className="space-y-4">
      <div className="bg-app-surface border border-app-border rounded-xl p-4">
        <div className="flex items-center gap-3 mb-3">
          <h3 className="text-sm font-medium text-app-text">Task State</h3>
          {fullState?.task_status && (
            <StatusBadge
              variant={
                fullState.task_status === 'completed'
                  ? 'success'
                  : fullState.task_status === 'error'
                    ? 'error'
                    : 'info'
              }
              dot
            >
              {fullState.task_status}
            </StatusBadge>
          )}
        </div>
        {fullState?.current_task && (
          <p className="text-sm text-app-text-sec mb-2">{fullState.current_task}</p>
        )}
        {fullState?.task_result && (
          <div className="mt-3 p-3 bg-app-bg rounded-lg">
            <p className="text-xs font-medium text-app-text-dim mb-1">Result:</p>
            <p className="text-sm text-app-text whitespace-pre-wrap">{fullState.task_result}</p>
          </div>
        )}
      </div>

      {fullState && (
        <div className="bg-app-surface border border-app-border rounded-xl p-4">
          <h3 className="text-sm font-medium text-app-text mb-2">Raw State</h3>
          <JsonViewer data={fullState} />
        </div>
      )}
    </div>
  );
}
